// directive.schema.json source — inbound control directives from CLI
// (`approve`/`pause`/`resume`/`answer`/`redirect`/`revert`/`abort`, §3.3) and
// Mattermost thread commands (`@avatar approve|pause|resume|redirect|
// answer|revert|abort`, §7.2). Both paths converge on inbox before the
// journal (§7.3: "CLI local có cùng approve/answer/redirect/revert qua
// inbox").
import { z } from "zod";

export const DirectiveKindSchema = z.enum([
  "approve",
  "pause",
  "resume",
  "answer",
  "redirect",
  "revert",
  "abort",
  "abort_confirm",
]);

// 06k C6: `chat_delegated` = phiên chat Claude Code duyệt/trả lời THAY chủ mission
// (`--delegated`) — ủy nhiệm, không bao giờ hiển thị như người duyệt.
export const DirectiveSourceSchema = z.enum(["cli_local", "mattermost", "chat_delegated"]);

export const DirectiveSchema = z
  .object({
    schema_version: z.literal(1),
    directive_id: z.string().min(1),
    mission_id: z.string().min(1),
    kind: DirectiveKindSchema,
    source: DirectiveSourceSchema,
    // Actor identity bound at setup (spec §"Gate, danh tính và tài nguyên":
    // "Nhận lệnh từ Mattermost user_id đã bind ở setup"). CLI local directives
    // carry the OS account identity instead of a Mattermost user id.
    actor_id: z.string().min(1),
    received_at: z.string().min(1),
    // approve: gate + request id; answer: ticket + request id + text;
    // redirect: free text; revert: ticket id; abort_confirm: challenge id.
    // Kept as a loosely-typed payload because each kind has a distinct shape
    // and the directive schema's job is envelope validation, not per-kind
    // business rules (those live in the controller, per §2/§9.1 "adapter
    // không hardcode logic nghiệp vụ").
    payload: z.record(z.string(), z.unknown()),
    // Server post id (Mattermost) used for de-duplication — spec §7.3: "Khử
    // trùng theo server post ID."
    source_post_id: z.string().optional(),
  })
  .strict();

export type Directive = z.infer<typeof DirectiveSchema>;
